import React, { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import MoveIcon from "@mui/icons-material/SwapHoriz";
import { Form, Modal } from "react-bootstrap";
import { Alert, Button, IconButton, Tooltip } from "@mui/material";
import { useChecklistContext } from "context/ChecklistContext";
import { useMoveChecklistMutation } from "app/api/checklists";
import { getErrorMessage } from "utilities/getErrorMessage";

const EditOrderNumber: React.FC = () => {
  const { checklist } = useChecklistContext();
  const [showModal, setShowModal] = useState(false);
  const [newOrderId, setNewOrderId] = useState("");
  const navigate = useNavigate();
  const [moveChecklist, { error }] = useMoveChecklistMutation();

  const handleClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setNewOrderId("");
  };

  const handleSave = (e: FormEvent) => {
    e.preventDefault();
    const requestBody = {
      checklistId: checklist.id,
      newOrderId: newOrderId,
    };

    moveChecklist(requestBody)
      .unwrap()
      .then(() => navigate(`/orders/view/${newOrderId}`))
      .catch(() => {}); // Error handling is done in the mutation
  };

  return (
    <>
      <Tooltip arrow title={<>Flytta checklistan till en annan order</>}>
        <IconButton size="small" onClick={handleClick}>
          <MoveIcon />
        </IconButton>
      </Tooltip>

      <Modal show={showModal} onHide={handleClose}>
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>Flytta checklistan till en annan order?</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Skriv in vilket ordernummer du vill flytta checklistan till</p>
            <Form.Control
              type="text"
              placeholder="Ordernr"
              value={newOrderId}
              onChange={(e) => setNewOrderId(e.target.value)}
            />
            {error && (
              <Alert severity="error" className="mt-3">
                {getErrorMessage(error)}
              </Alert>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button color="error" variant="contained" className="me-2" onClick={handleClose}>
              Avbryt
            </Button>

            {newOrderId === "" ? (
              <Button
                disabled
                variant="contained"
                onClick={() => {
                  console.log("disabled button was clicked!");
                }}
              >
                Spara
              </Button>
            ) : (
              <Button onClick={(e) => handleSave(e)} type="submit" variant="contained">
                Spara
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default EditOrderNumber;
